import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";
import { Link } from "react-router-dom";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="privacy">
      <Header />

      <section
        className="aside-navigation-main-content"
        data-test-id="aside-navigation-main-content"
      >
        {/*[*/}
        <div
          className="responsive-content responsive-content-page customer-service privacy"
          data-style="content-page"
        >
          <span />
          <div className="desktopContentWrapper">
            <div data-test="ecm-content-desktop-container">
              <div
                className="ecm-content-wrapper"
                data-style="ecm-content-wrapper"
              >
                <div
                  className="cq-ecm-pages general-page privacy-policy faq-rj-us"
                  data-page-title="Privacy Policy"
                >
                  <div id="text2036680822" className="text section breadcrumbs">
                    <ul className="breadcrumbs">
                      <li>
                        <Link onClick={toTop} to="/">
                          Home
                        </Link>
                      </li>

                      <li>
                        <h1>Privacy Policy</h1>
                      </li>
                    </ul>
                  </div>
                  <div id="text71914376" className="text section bulleted">
                    <h1>Privacy Policy</h1>
                    <p>
                      We are part of the Williams-Sonoma, Inc. Brands which
                      includes Williams-Sonoma, Pottery Barn, pottery barn kids,
                      Pottery Barn Teen, west elm, Retteve, Mark and Graham, and
                      GreenRow. Williams-Sonoma, Inc. Brands are committed to
                      respecting your privacy. The purpose of this Privacy
                      Policy is to inform you what information we collect from
                      you, how we use your information and the choices that you
                      have regarding our use of your information. This Privacy
                      Policy applies to information we collect about you in our
                      stores, through our websites and mobile applications, and
                      anywhere else we interact with you. By using any of our
                      web sites, mobile applications, or sharing your
                      information with us, you are accepting and consenting to
                      the practices described in this Privacy Policy.
                    </p>
                    <p>
                      Williams-Sonoma, Inc. Brands support and adhere to the
                      guidelines and practices adopted by the Direct Marketing
                      Association's Privacy Promise to American Consumers. We
                      have agreed to (1) provide customers with notice of their
                      ability to opt out of information rental, sale, or
                      exchange with other marketers; (2) honor customers'
                      requests not to share their contact information with other
                      marketers; and (3) honor customers' requests not to
                      receive mail, telephone, or other solicitations from
                      Williams-Sonoma, Inc. Brands.
                    </p>
                    <h2 id="pp-collecting">Collecting Information About You</h2>
                    <h3>
                      Categories and Types of Personal Information We Collect
                    </h3>
                    <p>
                      We collect the following categories and types of personal
                      information:
                    </p>
                    <ul>
                      <li>
                        Contact Information: your first and last name, postal
                        address, email address, and phone number;
                      </li>
                      <li>
                        Other identifying information: IP address, social media
                        user names, passwords and other security information for
                        authentication and access;
                      </li>
                      <li>
                        Financial Information: credit card, debit card and bank
                        account information;
                      </li>
                      <li>
                        Demographic information: gender, age, employment
                        information and salary information;
                      </li>
                      <li>Geolocation data;</li>
                      <li>
                        Internet or other electronic activity: your browsing and
                        click history, including information about how you
                        navigate within our services and which elements of our
                        services you use the most;
                      </li>
                      <li>
                        Commercial information: products purchased or viewed on
                        our website;
                      </li>
                      <li>
                        Audio and visual information: your videos and photos;
                        and
                      </li>
                      <li>
                        Inferences drawn from the categories described above in
                        order to create a profile about you to reflect your
                        preferences, characteristics, behavior and attitude.
                      </li>
                    </ul>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                    <h3>Categories of Use</h3>
                    <ul>
                      <li>
                        <b>Transactional Purposes:</b> We use your contact
                        information, financial information, and commercial
                        information to:{" "}
                        <ul>
                          <li>
                            Receive, process, confirm, send and track your
                            order, subscription or registration;
                          </li>
                          <li>
                            Communicate with you about your order, subscription
                            or registration;
                          </li>
                          <li>
                            Process any subscription or registration you make to
                            one of our services; and
                          </li>
                          <li>
                            Maintain your "Gift List" through your registry
                          </li>
                        </ul>
                      </li>
                      <li>
                        <b>Analytical Purposes:</b> We use your other
                        identifying information, internet activity and browsing
                        history, commercial information, demographic
                        information, and geolocation data to analyze
                        preferences, trends and statistics.
                      </li>
                      <li>
                        <b>Marketing and Promotional Purposes:</b> We use your
                        contact information, commercial information, demographic
                        information, internet or other electronic activity,
                        geolocation data, and inferences to:{" "}
                        <ul>
                          <li>
                            Inform you of our new products, services and offers;
                          </li>
                          <li>Provide you with targeted advertising;</li>
                          <li>Run contests, promotions and sweepstakes,</li>
                          <li>
                            Provide you with our loyalty program including
                            earning points and awarding and redeeming
                            certificates; and
                          </li>
                          <li>
                            Provide you with other information from and about
                            Williams-Sonoma, Inc. Brands, including personalized
                            marketing communications.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <b>
                          Maintenance and Improvement of Services and Website:
                        </b>{" "}
                        We use your contact information, commercial information,
                        and internet activity and browsing history to:{" "}
                        <ul>
                          <li>Provide and maintain our Design Lab services;</li>
                          <li>
                            Provide and maintain functionality on our website,
                            including our live chat or customer review features;
                          </li>
                          <li>Handle your customer services requests; and</li>
                          <li>
                            Help us diagnose technical and service problems and
                            administer our stores, websites and apps.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <b>Review and Content Creation Purposes:</b> We use your
                        contact information, commercial information, and audio
                        and visual information to enable reviews of our products
                        and to display content that you have created and allowed
                        us to display on our website and services and on social
                        media.
                      </li>
                      <li>
                        <b>Security and Fraud Prevention:</b> We use your
                        contact information, other identifying information,
                        commercial information, financial information,
                        geolocation data, internet activity and browsing
                        history, and inferences to protect this website, our
                        company, and others and to prevent fraud, theft and
                        misconduct.
                      </li>
                    </ul>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                    <h2 id="pp-sources">Sources of Personal Information</h2>
                    <p>We collect information from the following sources:</p>
                    <p>
                      <i>We collect information directly from you.</i> We
                      collect contact and demographic information directly from
                      you. We also collect payment information from you.
                    </p>
                    <p>
                      <i>
                        We collect information about you from third parties.
                      </i>{" "}
                      We collect your personal information from third parties,
                      such as social media sites and data co-ops. We use the
                      Google Maps service on our web sites and may use the
                      Google Maps service, and other services, to collect
                      geolocation data. We use this information to create
                      greater ease of use in our checkout, including to suggest
                      your shipping and billing address, or to help you find the
                      closest store location. The Google Maps service is
                      governed by Google's privacy policy located at{" "}
                      <Link
                        onClick={toTop}
                        to="https://www.google.com/policies/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        www.google.com/policies/privacy
                      </Link>
                      . We may collect your identifying information from
                      Facebook, in accordance with their terms of use and
                      privacy policy. We purchase from and trade contact
                      information, demographic information, commercial
                      information, and internet and electronic activity with
                      data co-ops and other third party data aggregators.
                    </p>
                    <p>
                      <i>We collect information from you passively.</i> We
                      collect Internet or other electronic activity passively
                      using tools like browser cookies. This activity is further
                      described in the Advertising and Online Tracking section
                      below.
                    </p>
                    <h3>
                      <i>Combining Information</i>
                    </h3>
                    <p>
                      We may combine information you give us online, in our
                      stores, or through our catalogs. We may also combine that
                      information with publicly available information and
                      information we receive from or cross-reference with third
                      parties. We use that combined information to enhance and
                      personalize your shopping experience with us, to
                      communicate with you directly about our products and
                      events that may be of interest to you, and for other
                      promotional and commercial purposes.
                    </p>
                    <h2 id="pp-sharing">
                      When We Share Information with Third Parties
                    </h2>
                    <h4>Our Service Providers</h4>
                    <p>
                      We may contract with companies or persons to provide
                      certain services including credit card processing,
                      shipping, data analysis and management, promotional
                      services, etc. We call them our Service Providers. We
                      provide our Service Providers with the information needed
                      for them to perform these services. We also ask our
                      Service Providers to confirm that their privacy practices
                      are consistent with ours.
                    </p>
                    <h4>Our Select Partners</h4>
                    <p>
                      From time to time we might establish a business
                      relationship with other persons or entities whom we
                      believe trustworthy and whom we have asked to confirm that
                      their privacy policies are consistent with ours. These are
                      known as our Select Partners. In such cases we might rent,
                      exchange, share and/or cross-reference information,
                      including contact information about you that will enable
                      such persons or entities to contact you regarding products
                      and services that may be of interest to you. This section
                      does not apply to mobile phone numbers and opt in consent
                      information collected for SMS text programs.
                      Williams-Sonoma, Inc. Brands may also collect mobile phone
                      numbers for other purposes which are subject to this
                      section.
                    </p>
                    <h4>Our Affiliates</h4>
                    <p>
                      We may share personal information with businesses
                      controlling, controlled by, or under common control with
                      any Williams-Sonoma, Inc. Brands.
                    </p>
                    <h4>Corporate Transactions</h4>
                    <p>
                      We may share personal information with parties to business
                      transactions such as those we deal with in mergers,
                      acquisitions, joint ventures, sales of assets,
                      reorganizations, divestitures, dissolutions, bankruptcies,
                      liquidations, or other types of business transactions. In
                      these types of transactions, personal information may be
                      shared, sold, or transferred, and it may be used
                      subsequently by a third party.
                    </p>
                    <h4>Law Enforcement and Courts</h4>
                    <p>
                      In certain instances we may disclose your contact
                      information when we have reason to believe that it is
                      necessary to identify, contact or bring legal action
                      against persons or entities who may be causing injury to
                      you, to Williams-Sonoma, Inc. Brands or to others. We may
                      also disclose your contact information when we believe the
                      law or legal process requires it.
                    </p>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                    <h2 id="pp-cookies">Cookies</h2>
                    <p>
                      When you visit our web sites, we send one or more cookies
                      to your computer or other device. We may also use cookies
                      and other similar technologies in emails that you receive
                      from us. A cookie is a small data file that is placed on
                      the hard drive of your computer when you visit a web site.
                      A session cookie expires immediately when you end your
                      session (i.e., close your browser). A persistent cookie
                      stores information on the hard drive so when you end your
                      session and return to the same web site at a later date
                      the cookie information is still available. We use cookies
                      to improve the quality of our service when you visit our
                      web site and other web sites of interest to you. We also
                      use cookies to remind us of who you are, tailor our
                      products, services and advertising to suit the personal
                      interests of you and others, estimate our audience size,
                      assist our online merchants to track visits to and sales
                      at our web sites and to process your order, track your
                      status in our promotions, contests and sweepstakes, and/or
                      analyze your visiting and email interaction patterns.
                    </p>
                    <p>
                      If you would like to opt out of accepting cookies
                      altogether, you can generally set your browser to not
                      accept cookies or to notify you when you are sent a
                      cookie, giving you the chance to decide whether or not to
                      accept it. However, certain features of our web sites or
                      other services may not work if you delete or disable
                      cookies.
                    </p>
                    <p>
                      We use Google Analytics on our web sites to collect usage
                      data, to analyze how users use the web sites and to
                      provide advertisements to you on other websites. For more
                      information about how to opt out of having your
                      information used by Google Analytics, visit{" "}
                      <Link
                        onClick={toTop}
                        to="https://tools.google.com/dlpage/gaoptout/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://tools.google.com/dlpage/gaoptout/
                      </Link>
                      .
                    </p>
                    <h2 id="pp-browsing-session-info">
                      Browsing Session Information
                    </h2>
                    <p>
                      We use technologies that maintain records of your browsing
                      session, chats, and other activities on our Site. These
                      technologies may include session replay that maintains a
                      record of your interactions with our Site, chat providers
                      that maintain a transcript of your chats, cookies, pixels,
                      and other tracking technologies that share some of your
                      interactions with our Site, as well as other technologies
                      that collect and share your interactions with our
                      Site.&nbsp;We use this information for quality control,
                      customer service, fraud prevention and security, and
                      marketing purposes.
                    </p>
                    <h2 id="pp-tracking">Advertising and Online Tracking</h2>
                    <p>
                      We allow third-party companies to serve ads and/or collect
                      certain information when you visit our web sites. These
                      companies may use information (e.g., click stream
                      information, browser type, time and date, subject of
                      advertisements clicked or scrolled over) collected during
                      your visits to this and other web sites in order to
                      provide advertisements about goods and services likely to
                      be of interest to you. These companies may also tie
                      identifiers associated with a particular browser or device
                      to identifiers associated with other browsers or devices
                      used by the same user or household (e.g., a device
                      identifier associated with a user's computer may be tied
                      to the device identifiers of that user's tablet and phone)
                      in order to measure and target advertisements tailored to
                      user interests across their devices and to send
                      personalized marketing communications. These companies
                      typically use a cookie, tracking pixels or third party web
                      beacons to collect this information. These companies may
                      also serve advertisements to you, using other personal
                      information, such as your email address. Our systems do
                      not recognize "Do Not Track" signals, but several of these
                      third party companies who utilize these cookies or beacons
                      on our web sites enable you to opt out of this behavioral
                      advertising. To learn more or opt out from these companies
                      you can visit{" "}
                      <Link onClick={toTop} to="/">
                        http://www.networkadvertising.org/choices
                      </Link>{" "}
                      . We also provide you with additional tools to opt out of
                      marketing from us or certain transfers of your
                      information. You can learn about this in the "Opting Out
                      of Marketing and Transfers" section of this Privacy
                      Policy.
                    </p>
                    <h2 id="pp-opt-out">
                      Opting Out Of Marketing And Transfers; Updating
                      Information About You
                    </h2>
                    <p>
                      We want to communicate with you only if you want to hear
                      from us. If you prefer not to receive direct marketing
                      from us or from our Select Partners, or if you would like
                      to opt out of our rental or exchange of your information
                      with other marketers, please let us know. In the U.S., you
                      can call us at{" "}
                      <Link onClick={toTop} to="tel:888-401-1900">
                        888-401-1900
                      </Link>
                      . Outside of the U.S., you can call us at{" "}
                      <Link onClick={toTop} to="tel:405-717-6139">
                        405-717-6139
                      </Link>
                      . If you would like to update or correct your email
                      address, mailing address or other contact information with
                      us please contact us the same way.
                    </p>
                    <p>
                      You may also click the designated link at the bottom of
                      all email advertisements to be removed from future email
                      updates.
                    </p>
                    <p>
                      Please note that any requests to remove or update your
                      contact information may take up to five days for your
                      email request and 6-8 weeks to process your postal mail
                      request.
                    </p>
                    <p>
                      We may need to contact you via phone, email or mail to
                      address questions or issues specific to your order, entry,
                      etc., even if you have opted to not receive marketing
                      communications from us. We contact you only in ways
                      compatible with your communications choices. To the extent
                      necessary for such purposes, we take reasonable steps to
                      make sure that your contact information is accurate,
                      complete, current, and otherwise reliable.
                    </p>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                    <h2 id="pp-ccpa">
                      Privacy Rights Under Certain State Privacy Laws
                    </h2>
                    <p>
                      If you are a resident of California, Colorado,
                      Connecticut, Delaware, Iowa, Maryland, Minnesota, Montana,
                      Nebraska, New Hampshire, New Jersey,&nbsp;Oregon,
                      Tennessee, Texas, Utah, Virginia, Indiana, Kentucky, or
                      Rhode Island, you may have certain privacy rights under
                      the applicable privacy laws in your state (“State Privacy
                      Laws”). This section describes those rights and how you
                      can exercise them with Williams-Sonoma, Inc. Brands.
                    </p>
                    <p className="subsection-title">
                      <b>Rights Requests</b>
                    </p>
                    <p className="subsection-sub-title">
                      Right to Know, Right to Deletion and Right to Correct
                    </p>
                    <p>
                      You can request what personal information we have
                      collected, used, disclosed, and sold and a portable copy
                      of that personal information (right of access).
                    </p>
                    <p>
                      If you are a Delaware, Maryland, Minnesota or Oregon
                      resident, you can also request a list of specific third
                      parties, as defined under Delaware, Maryland, Minnesota
                      and Oregon laws, to which we have disclosed personal
                      information.
                    </p>
                    <p>
                      You can also request that we delete your personal
                      information. We may not delete all of your personal
                      information if one of the following exceptions applies:
                    </p>
                    <ul>
                      <li>
                        <b>Transactional:</b> to complete a transaction for
                        which the personal information was collected, provide a
                        good or service requested by you, or perform a contract
                        we have with you;
                      </li>
                      <li>
                        <b>Security:</b> to detect data security incidents;
                        preserve the integrity or security of systems; or
                        investigate, report, or prosecute those responsible for
                        any such action;
                      </li>
                      <li>
                        <b>Error Correction:</b> to debug or repair any errors;
                      </li>
                      <li>
                        <b>Legal:</b> to protect against fraud, harassment,
                        malicious or deceptive activities, or illegal activity
                        or to comply with applicable law or a legal obligation,
                        or exercise rights under the law, such as the right to
                        free speech; to assist another party with any of its
                        obligations under applicable privacy laws; or
                      </li>
                      <li>
                        <b>Internal Use:</b> to use your personal information,
                        internally, in a lawful manner that is compatible with
                        the context in which you provided the information (i.e.
                        to improve our services).
                      </li>
                    </ul>
                    <p>
                      <b>
                        Please note that if we delete your personal information,
                        many of our services will not work the same. Some
                        examples include, but are not limited to:
                      </b>
                    </p>
                    <ul>
                      <li>
                        Returns: We will not have the ability to look up your
                        receipt or order in our system. In order to process a
                        return or refund, we will require proof of purchase from
                        the customer and if the customer is unable to provide
                        proof of purchase, the transaction will be treated as an
                        unreceipted return in accordance with our return policy.
                      </li>
                      <li>
                        Customer Service: Our ability to handle customer service
                        requests may be limited. We will not have the ability to
                        look up prior orders or account information and may
                        request proof of purchase in order to service your
                        needs.
                      </li>
                      <li>
                        Online Account &amp; Shopping: Your online account will
                        no longer exist. Your shopping cart items, order
                        history, saved addresses, saved recipes and any other
                        saved preferences in your online account will no longer
                        be available.
                      </li>
                      <li>
                        Loyalty Program: You will lose your loyalty account and
                        any points earned as part of your participation in Key
                        Rewards. You will not be able to accrue loyalty points
                        moving forward. Any existing reward certificates will be
                        honored. You will also no longer be eligible for loyalty
                        specific benefits such as exclusive events and early
                        access offers.
                      </li>
                      <li>
                        Recalls: We will no longer be able to contact you via
                        email, regular mail, or phone about product recalls
                        related to products you purchased, unless you provided
                        your information to us by returning a product
                        registration card attached to a durable infant product.
                      </li>
                      <li>
                        Gift Registry: You will no longer be able to view or add
                        items to your gift registry. Reference to your name in a
                        joint registry will be deleted.
                      </li>
                      <li>
                        Marketing Communications: We will no longer be able to
                        provide you with any marketing communications directly
                        from our family of brands, including personalized
                        marketing communication such as information about new
                        products, services and offers tailored to your
                        interests.
                      </li>
                      <li>
                        To the Trade: If you submit a deletion request under
                        your “To The Trade” profile, your personal information
                        from your customer account will also be deleted.
                      </li>
                      <li>
                        Opt Outs: Previous opt-out requests will not be saved.
                      </li>
                    </ul>
                    <p>
                      You may also request that we correct certain inaccurate
                      information that we have about you.
                    </p>
                    <p>
                      To submit a request to know, a request to correct or a
                      request to delete, please visit{" "}
                      <Link
                        onClick={toTop}
                        className="privacy-policy-opt-out-link"
                        to="/"
                      >
                        Truyo Portal
                      </Link>{" "}
                      or call 833.922.7529. In order to verify your identity,
                      you will need to provide at least three of the following
                      pieces of your information: name, telephone number, e-mail
                      address, mailing address, and last transaction amount. We
                      will match this information to the information on our
                      systems. For an online request to delete, we will also
                      send you a second verification to confirm that you want
                      your information to be deleted. In order to designate an
                      authorized agent to act on your behalf you must provide
                      the authorized agent with written permission to do so, and
                      your authorized agent must submit that written proof at
                      the time they make the request on your behalf. If you wish
                      to make multiple requests under this section, we recommend
                      sending the deletion request last, as we will not be able
                      to fulfill your other requests once we have deleted your
                      information. We will maintain a record of your request to
                      know or request to delete. For a faster way to correct
                      your information, you may go to your WSI account to
                      correct it yourself. Note that the correction of your
                      information for the Gold Rewards Program must be done
                      through Capital One Customer Service at 1-877-383-4802.
                    </p>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                    <h2 id="do-not-sell">
                      Do Not Sell or Share/Use My Personal Information for
                      Targeted Advertising
                    </h2>
                    <h4>
                      Personal Information that We Sell or Share/Use for
                      Targeted Advertising
                    </h4>
                    <p>
                      Under California law, "share" means disclosing your
                      personal information by us to a third party for
                      cross-context behavioral advertising, in exchange for
                      money or anything else of value. Thus, when we use the
                      term “share” under this section, we are using it in the
                      narrow meaning of how it is defined under California law.
                      Other State Privacy Laws do not use the term “share,” but
                      describe the concept as using personal information for
                      targeted advertising.
                    </p>
                    <p>
                      Under some state privacy laws (such as California) "sell"
                      means exchanging your personal information by us with a
                      third party for money or anything else of value. Under
                      other laws (such as Virginia), "sell" is the exchange of
                      personal information for money only. We do not engage in
                      the latter.
                    </p>
                    <p>
                      Through our participation in digital advertising networks
                      and in connection with our Select Partners, we may sell or
                      share/use for targeted advertising, the following
                      categories of personal information:
                    </p>
                    <ul>
                      <li>Identifiers</li>
                      <li>
                        Characteristics of protected classifications under
                        California and federal law;
                      </li>
                      <li>Internet/electronic activity;</li>
                      <li>Commercial information; and</li>
                      <li>
                        Inferences drawn from the categories described above in
                        order to create a profile about you to reflect your
                        preferences, characteristics, preferences, behavior and
                        attitudes.
                      </li>
                    </ul>
                    <p>
                      We do not knowingly sell or share/use for targeted
                      advertising the personal information of minors under the
                      age of 16.
                    </p>
                    <h4>
                      Right to Opt Out of Sale or Sharing/Using Your Personal
                      Information for Targeted Advertising
                    </h4>
                    <p>
                      You can opt-out of us selling or sharing/using your
                      personal information for targeted advertising for online
                      activity by enabling an opt out preference signal for a
                      browser or plug-in that makes it clear that such signal is
                      meant to have the effect of opting you out of the sale and
                      sharing of your Personal Information. To opt out of online
                      and offline selling or sharing, please visit the{" "}
                      <Link
                        onClick={toTop}
                        className="privacy-policy-opt-out-link"
                        to="/"
                      >
                        Truyo Portal
                      </Link>{" "}
                      or call us at 833.922.7529. Note that if you are logged
                      into your online account, we will process such request for
                      offline sales also, but if we only can identify your
                      device or browser, we will only be able to apply the
                      request to that specific device or browser and only for
                      cookie or pixel based selling and sharing. Note that if
                      you clear your cookies, your opt out request will no
                      longer be saved for that browser.&nbsp;Additionally, if
                      you opt out of selling or sharing/using your personal
                      information for targeted advertising while located in the
                      EU, only offline selling or sharing can be processed due
                      to the limited functionality of our web sites for EU
                      visitors.&nbsp; In order to effectuate your opt out of
                      online sharing and selling, please click the Truyo link
                      above again from within the United States.&nbsp; You do
                      not need to fill out the request form again.
                    </p>
                    <p>
                      In order to designate an authorized agent to act on your
                      behalf you must provide the authorized agent with written
                      permission to do so, and your authorized agent must submit
                      that written proof at the time they make the request on
                      your behalf.
                    </p>
                    <p>
                      We do not “sell” or “share” Sensitive Personal Information
                      (as defined under State Privacy Laws).
                    </p>
                    <h4>Non-Discrimination</h4>
                    <p>
                      We will not discriminate against you for exercising any of
                      your rights under State Privacy Laws and we will not deny
                      you goods or services, charge you a different price, or
                      provide you with a lesser quality of goods or services if
                      you exercise any of your rights under State Privacy Laws.
                    </p>
                    <p>
                      <Link
                        onClick={toTop}
                        name="financial-incentives"
                        id="financial-incentives"
                      />
                    </p>
                    <h4 id="financial-incentives">
                      Financial Incentives and Loyalty Program
                    </h4>
                    <p>
                      We offer various financial incentives and a loyalty
                      program (Colorado law uses the term “bona fide loyalty
                      program”). The terms of the financial incentive and bona
                      fide loyalty program will be presented to you at the time
                      you sign up.
                    </p>
                    <p>
                      Please see our “Do Not Sell or Share/Use My Personal
                      Information for Targeted Advertising” section above for
                      the categories of information that will be sold or
                      processed for targeted advertising purposes, which also
                      applies to personal information collected in connection
                      with our loyalty program.
                    </p>
                    <p>
                      Third parties who will receive personal information
                      collected in connection with our loyalty program are
                      described in “When We Share Information with Third
                      Parties” section above.
                    </p>
                    <p>
                      You may withdraw from any of the financial incentives or
                      the loyalty program by contacting us at 800.541.1262, or
                      by unsubscribing to our email marketing by visiting our
                      website. As described above, if you submit a deletion
                      request, we will delete your loyalty account and any
                      points earned as part of your participation in the program
                      and you will not be able to accrue loyalty points or
                      participate in the program moving forward. We need your
                      name and email address or phone number to connect your
                      loyalty account to purchases you make in order to earn and
                      redeem points. We are unable to provide these benefits of
                      the loyalty program without that information.
                    </p>
                    <p>
                      The value of your data is the value of the offer presented
                      to you. We have calculated the value of the incentive by
                      using the expense related to the offer.
                    </p>
                    <h4>Right to Opt out of Profiling</h4>
                    <p>
                      If you are a resident of Colorado, Connecticut, Delaware,
                      Iowa, Maryland, Minnesota,&nbsp;Montana, Nebraska, New
                      Hampshire, New Jersey, Oregon, Tennessee, Texas, Virginia,
                      or Rhode Island, you have a right to opt out of any form
                      of automated processing performed on personal information
                      to evaluate, analyze or predict personal aspects related
                      to your economic situation, health, personal preferences,
                      interests, reliability, behavior, location or movements
                      (“Profiling”). To submit a request to opt out of Profiling
                      that is not cookie-based or digital advertising-based
                      Profiling, please visit the{" "}
                      <Link
                        onClick={toTop}
                        className="privacy-policy-opt-out-link"
                        to="/"
                      >
                        Truyo Portal
                      </Link>{" "}
                      or call us at 800.541.1262. In order to verify your
                      identity, we will send you a verification email. In order
                      to designate an authorized agent to act on your behalf you
                      must provide the authorized agent with written permission
                      to do so, and your authorized agent must submit that
                      written proof mailed to the address below so that it is
                      received prior to the time the agent makes the request on
                      your behalf. To opt out of cookie-based or digital
                      advertising-based Profiling, please opt out of the
                      selling/sharing of your information for targeted
                      advertising, as described above. Note that if you opt out
                      of profiling, your experience with our brands will be less
                      personalized.
                    </p>
                    <p>
                      We will not be able to opt you out of Profiling where one
                      of the following exceptions applies:
                    </p>
                    <ul>
                      <li>
                        Legal: to comply with applicable laws, rules or
                        regulations; to comply with a civil, criminal, or
                        regulatory inquiry, investigation, subpoena, or summons
                        by governmental authorities; to cooperate with law
                        enforcement; to investigate, exercise, prepare for or
                        defend actual or anticipated legal claims; or to assist
                        another party with any of its obligations under
                        applicable laws;
                      </li>
                      <li>
                        Security: to prevent, detect, protect against, or
                        respond to security incidents, identity theft, fraud,
                        harassment, or malicious, deceptive, or illegal
                        activity; preserve the integrity or security of systems;
                        or investigate, report, or prosecute those responsible
                        for any such action;
                      </li>
                      <li>
                        Improvement of Services and Products/Internal use: to
                        conduct internal research to improve, repair or develop
                        products, services or technology;
                      </li>
                      <li>
                        Transactional: to provide a product or service
                        specifically requested by you; to complete a transaction
                        with you or to complete a contract we have with you; and
                      </li>
                      <li>
                        Public Interest: to protect your vital interests or
                        those of another individual.
                      </li>
                    </ul>
                    <h4>Right to Appeal</h4>
                    <p>
                      If we denied your request, you may appeal the denial by
                      clicking on the link to appeal found in the email
                      communication we sent when your original request was
                      completed.
                    </p>
                    <h4>Sensitive Personal Information</h4>
                    <p>
                      We do not collect or process Sensitive Personal
                      Information, as defined by California Law, for inferring
                      characteristics or use or disclose Sensitive Personal
                      Information for purposes other than those permitted by
                      law.
                    </p>
                    <h4>Retention</h4>
                    <p>
                      We will store your personal information for as long as is
                      reasonably necessary to fulfill the purposes described in
                      this Privacy Policy or as required by law.
                    </p>
                    <h4>Metrics</h4>
                    <p>
                      Below are the metrics for the California consumer requests
                      pursuant to CCPA that we received, complied with (in whole
                      or in part) and denied between January 1, 2024 and
                      December 31, 2024. Note that denied requests include
                      requests that failed due to lapsed or failed verification
                      or requests where an agent did not provide sufficient
                      verification of their authority to make the request.
                    </p>
                    <div className="plain-list">
                      <ul>
                        <li>Requests to know:</li>
                        <li>Received: 8</li>
                        <li>Complied with in whole or in part: 5</li>
                        <li>Denied: 3</li>
                        <li>Median time to substantively respond: 14 days</li>
                      </ul>
                      <ul>
                        <li>Requests to delete:</li>
                        <li>Received: 207</li>
                        <li>Complied with in whole or in part: 112</li>
                        <li>Denied: 95</li>
                        <li>Median time to substantively respond: 29 days</li>
                      </ul>
                      <ul>
                        <li>Requests to opt-out of sale:</li>
                        <li>Received: 889</li>
                        <li>Complied with in whole or in part: 889</li>
                        <li>Median time to substantively respond: 0 days</li>
                      </ul>
                    </div>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                    <h2>EU Privacy Rights</h2>
                    <p>
                      Please note that we offer a view-only version of our web
                      sites for people accessing our web sites from the
                      EU.&nbsp; Many of the features and functionalities of our
                      web site are not offered to visitors in the EU and
                      visitors from the EU cannot make purchases on our web
                      sites.&nbsp;
                    </p>
                    <p>
                      The data controller for our web site is Williams-Sonoma,
                      Inc., 3250 Van Ness Ave. San Francisco, CA 94123,
                      405.717.6139
                    </p>
                    <h4>
                      Categories and Types of Personal Information We Collect
                    </h4>
                    <p>
                      We collect the following categories and types of personal
                      information:
                    </p>
                    <ul>
                      <li>
                        Other identifying information: IP address, and other
                        security information for authentication and access;
                      </li>
                      <li>
                        Internet or other electronic activity: your browsing and
                        click history, including information about how you
                        navigate within our services and which elements of our
                        services you use the most;
                      </li>
                      <li>
                        Commercial information: products viewed on our website;
                        and
                      </li>
                      <li>
                        Inferences drawn from the categories described above in
                        order to create a profile about you to reflect your
                        preferences, characteristics, behavior and attitude.
                      </li>
                    </ul>
                    <h4>
                      Categories and Types of Personal Information We Collect
                    </h4>
                    <ul>
                      <li>
                        Analytical Purposes:&nbsp;We use your other identifying
                        information, internet activity and browsing history, and
                        commercial information to analyze preferences, trends
                        and statistics.
                      </li>
                      <li>
                        Maintenance and Improvement of Services and
                        Website:&nbsp;We use your commercial information, and
                        internet activity and browsing history to:{" "}
                        <ul>
                          <li>Provide and maintain our Design Lab services;</li>
                          <li>
                            Provide and maintain functionality on our website;
                          </li>
                          <li>Handle your customer services requests; and</li>
                          <li>
                            Help us diagnose technical and service problems and
                            administer our stores, websites and apps.
                          </li>
                        </ul>
                      </li>
                      <li>
                        Security and Fraud Prevention:&nbsp;We use your other
                        identifying information, commercial information,
                        internet activity and browsing history, and inferences
                        to protect this website, our company, and others and to
                        prevent fraud, theft and misconduct.
                      </li>
                    </ul>
                    <h4>Lawful Bases for Use</h4>
                    <p>
                      We use the personal information we collect, alone or in
                      combination with other information that we may collect
                      about you, for the maintenance purposes set out above,
                      that are necessary for the performance of the contract
                      between us, to provide you with the products or services
                      you requested, or that we consider in our legitimate
                      interests as detailed in this Privacy Policy.
                    </p>
                    <p>
                      When required by law, we rely on your voluntary consent to
                      process your information for marketing and promotional
                      purposes, including if we share your personal information
                      with any third-party for marketing purposes.
                    </p>
                    <p>
                      Finally, to comply with our legal obligations, we may use
                      your information for security and fraud prevention
                      purposes described above.
                    </p>
                    <h4>Your EU Privacy Rights</h4>
                    <p>
                      With respect to your personal information, you have the
                      right to:
                    </p>
                    <ul>
                      <li>
                        request access to and be provided with information on
                        the processing of your personal information (commonly
                        known as a "data subject access request"). This enables
                        you to receive a copy of the personal information we
                        hold about you and to check that we are lawfully
                        processing;
                      </li>
                      <li>
                        request corrections of your personal information if such
                        personal information proves inaccurate or incomplete,
                        though we may need to verify the accuracy of the new
                        data you provide to us;
                      </li>
                      <li>
                        request your personal information to be deleted (i) if
                        it is no longer necessary for the purposes described in
                        this Privacy Policy, (ii) should you decide to withdraw
                        your consent where you gave it, (iii) should you object
                        to its processing for direct marketing purposes, (iv)
                        should you identify that it would have been unlawfully
                        processed, (v) should we be under a legal obligation to
                        erase it to comply with EU law or the law of an EU
                        country and always provided we are not under a legal
                        obligation to keep it;
                      </li>
                      <li>
                        restrict the processing of your personal information (i)
                        if you contest its accuracy; (ii) if the processing is
                        unlawful and you oppose the erasure; (iii) if it is no
                        longer needed for the purposes set out in this Privacy
                        Policy but you require it for the establishment,
                        exercise or defense of a legal claim, (iv) if you object
                        to profiling;
                      </li>
                      <li>
                        request the transfer of your personal information to you
                        or to a third-party. We will provide to you, or a
                        third-party you have chosen, your personal information
                        in a structured, commonly used, machine-readable format.
                        Note that this right only applies to automated
                        information which you initially provided consent for us
                        to use or where we used the information to perform a
                        contract with you;
                      </li>
                      <li>
                        withdraw consent at any time where we are relying on
                        consent to process your personal information. However,
                        this will not affect the lawfulness of any processing
                        carried out before you withdraw your consent. If you
                        withdraw your consent, we may not be able to provide
                        certain products or services to you. We will advise you
                        if this is the case at the time you withdraw your
                        consent;
                      </li>
                      <li>
                        object to the processing of your personal information
                        for direct marketing purposes or to any processing which
                        we would have based on our legitimate interest (e.g.
                        profiling). In some cases, we may demonstrate that we
                        have compelling legitimate grounds to process your
                        information which override your rights and freedoms;
                      </li>
                      <li>
                        receive personal information which you provided to us in
                        a structured, commonly used and machine-readable format
                        and to transmit it to another provider provided it is
                        processed based on your consent or our contract;
                      </li>
                      <li>
                        lodge a complaint with your relevant data protection
                        authority.
                      </li>
                    </ul>
                    <p>
                      If you wish to exercise any of your above rights, please
                      reach out to us at qty@retteve.store.
                    </p>
                    <p>
                      Please note that we may require you to verify your
                      identity in order to process a request made to exercise
                      your rights in relation to your personal information. If
                      we are unable to match this information, we may ask you to
                      provide additional identifying information, such as a copy
                      of your passport or drivers’ license. You may designate a
                      third party to act on your behalf provided they have
                      appropriate written authority to do so.
                    </p>
                    <p>
                      If you make a request to delete your personal information,
                      note that we may not delete all of your information. We
                      may still process your personal information if it is
                      necessary to do so and we are lawfully permitted. For
                      example, in the following circumstances:
                    </p>
                    <p>
                      Security and Maintenance: in the context of detecting
                      and/or preventing security incidents, preserve the
                      integrity or security of systems; or investigate, report,
                      or prosecute those responsible for any such action, and/or
                      to debug or repair any errors; or
                    </p>
                    <p>
                      Legal: to protect against fraud or illegal activity or to
                      comply with applicable laws or resolve legal claims or
                      exercise rights under applicable laws and to assist
                      another party with any of its obligations under applicable
                      privacy laws (to the extent permitted under applicable
                      laws)
                    </p>
                    <p>
                      If you remain unhappy with a response you receive from us
                      you can refer the matter to your local data protection
                      supervisory authority (for example, see European
                      authorities here  
                      <Link onClick={toTop} to="/">
                        http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm
                      </Link>
                      ).
                    </p>
                    <p>
                      You will not have to pay a fee to access your personal
                      information (or to exercise any of the other rights). We
                      may, however, charge a reasonable fee if your request is
                      clearly unfounded, repetitive or excessive. Alternatively,
                      we could refuse to comply with your request in these
                      circumstances. We try to respond to all legitimate
                      requests within one month. It could take us longer than a
                      month if your request is particularly complex or you have
                      made a number of requests.
                    </p>
                    <p>
                      For information about the cookies we use on the web sites
                      for users in the EU and for those users to manage their
                      choices regarding information collected through cookies,
                      you may also click here.
                    </p>
                    <p>
                      Your web browser or mobile device may also provide
                      additional tools to allow you to control when your device
                      provides specific categories of information (for example
                      location data or cookies use). Please be aware of these
                      tools.
                    </p>
                    <p>
                      We do not collect any Special Categories of Personal
                      information about you (this includes details about your
                      race or ethnicity, religious or philosophical beliefs, sex
                      life, sexual orientation, political opinions, trade union
                      membership, information about your health, and genetic and
                      biometric data). Nor do we collect any information about
                      criminal convictions and offences.
                    </p>
                    <p>
                      Where we need to collect personal information by law, or
                      under the terms of a contract we have with you, and you
                      fail to provide that data when requested, we may not be
                      able to perform the contract we have or are trying to
                      enter into with you (for example, to provide you with
                      goods). In this case, we may have to cancel a product or
                      service you have with us, but we will notify you if this
                      is the case at the time.
                    </p>
                    <h2 id="pp-international">
                      International Customer Privacy
                    </h2>
                    <p>
                      If you choose to provide Williams-Sonoma, Inc. Brands with
                      your information, you consent to the transfer and storage
                      of that information on our servers located in the United
                      States.
                    </p>
                    <p>
                      For international customers, any questions or concerns
                      regarding the use or disclosure of your information should
                      be directed to Williams-Sonoma, Inc. Brands by calling us
                      at 405.717.6139. We will investigate and attempt to
                      resolve complaints and disputes regarding use and
                      disclosure of your information in accordance with this
                      Privacy Policy.
                    </p>
                    <h2 id="pp-international">
                      Security
                      <br />
                    </h2>
                    <p>
                      We maintain physical, electronic, and procedural
                      safeguards to protect the confidentiality and security of
                      information transmitted to us. To guard your information
                      delivered to us electronically, our web sites use Secure
                      Sockets Layer (SSL). SSL encrypts your credit card number,
                      name and address so only we are able to decode your
                      information. Unfortunately, however, no data transmission
                      over the Internet can be guaranteed to be 100% secure. As
                      a result, while we strive to protect your contact
                      information, to the extent permitted by law, we do not
                      guarantee or warrant the security of any information you
                      transmit to or from our web sites, and you do so at your
                      own risk.
                    </p>
                    <p>
                      We urge you to keep any password that you establish with
                      us in a safe place and not to divulge it to anyone. Also
                      remember to log off your account and close your browser
                      window when you have finished your visit. This is to
                      ensure that others cannot access your account, especially
                      if you are sharing a computer with someone else or are
                      using a computer in a public place.
                    </p>
                    <h2 id="pp-children">Protecting Children</h2>
                    <p>
                      We do not knowingly collect personal information from
                      children under 13. If you are a parent or guardian and you
                      are aware that any of your children has provided us with
                      personal information without your consent, please contact
                      us and we will take steps to remove that information from
                      our servers.
                    </p>
                    <h2 id="pp-links">Links to Third Party Web Sites</h2>
                    <p>
                      Our web sites may contain links to web sites operated and
                      maintained by third parties, over which we have no
                      control. Privacy policies on such linked web sites may be
                      different from our privacy policy. You access such linked
                      web sites at your own risk. You should always read the
                      privacy policy of a linked web site before disclosing any
                      of your information on such web site.
                    </p>
                    <h2 id="pp-changes">Policy Changes</h2>
                    <p>
                      If we decide to change our privacy policy in whole or in
                      part, we will inform you by posting a notice on our web
                      sites, as applicable. Those changes will go into effect on
                      the effective date posted in the notice and at the end of
                      the revised Privacy Policy. The new policy will apply to
                      all current and past users of our web sites and will
                      replace any prior policies that are inconsistent. Your
                      continued use of our web sites or other services
                      constitutes your acceptance of the practices described in
                      the revised Privacy Policy.
                    </p>
                    <h2 id="pp-contact">Contact Us</h2>
                    <p>
                      In the U.S., you can call us at 800.541.1262. Outside of
                      the U.S., you can call us at 405.717.6139.
                    </p>
                    <p>
                      Last Updated: <b>January 1, 2026</b>
                    </p>
                    <p>
                      <Link onClick={toTop} to="#top">
                        ▲ Back to Top
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              {/**/}
            </div>
          </div>
          <div className="mobileContentWrapper" style={{ display: "none" }}>
            <div>
              <div
                className="ecm-content-wrapper"
                data-style="ecm-content-wrapper"
              />
            </div>
          </div>
          <div className="ecm-content-script-container" />
          <div className="ecm-content-style-container" />
        </div>
        {/**/}
        {/**/}
        {/**/}
        {/*]*/}
      </section>

      <Footer />
    </div>
  );
}

export default Privacy;
